/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// @ts-expect-error - themeDisplay is a global object
const themeDisplay = window.themeDisplay || {
	getCompanyId: () => 0,
	getLanguageId: () => 'en_US',
};

export default themeDisplay;
